import React from 'react';

/**
 * AdminPageLoader
 * A reusable content-area loader that renders below the page header.
 * The navbar, sidebar, and static page heading all remain visible.
 *
 * Props:
 *   message {string} - Status label shown below the animation.
 *                      Defaults to "Loading..."
 */
function AdminPageLoader({ message = 'Loading...' }) {
  return (
    <div className="admin-page-loader-inline">
      <div className="admin-loader-content">
        {/* Concentric spinning rings */}
        <div className="admin-loader-rings">
          <div className="admin-loader-ring admin-loader-ring-1"></div>
          <div className="admin-loader-ring admin-loader-ring-2"></div>
          <div className="admin-loader-ring admin-loader-ring-3"></div>
          <div className="admin-loader-icon">
            <svg width="32" height="32" viewBox="0 0 24 24" fill="none">
              <path
                d="M3 9l9-7 9 7v11a2 2 0 01-2 2H5a2 2 0 01-2-2z"
                stroke="#1A237E"
                strokeWidth="2"
                strokeLinecap="round"
                strokeLinejoin="round"
              />
              <polyline
                points="9 22 9 12 15 12 15 22"
                stroke="#1A237E"
                strokeWidth="2"
                strokeLinecap="round"
                strokeLinejoin="round"
              />
            </svg>
          </div>
        </div>

        {/* Shimmer progress bar */}
        <div className="admin-loader-bar-wrapper">
          <div className="admin-loader-bar"></div>
        </div>

        {/* Dynamic status message */}
        <p className="admin-loader-status">{message}</p>
      </div>
    </div>
  );
}

export default AdminPageLoader;
